export default __webpack_public_path__ + "static/media/FinanceFXRates.66af7d28.png";